<script lang="ts" setup>
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import type { AsyncDataRequestStatus } from "#app/composables/asyncData";

const loading = defineModel<boolean>("loading", { default: false });

const status = defineModel<AsyncDataRequestStatus | undefined>("status", {
    default: undefined,
});

const as = defineModel<any>("as", { default: "template" });
const classes = defineModel<any>("class", { default: undefined });
const loaderClasses = defineModel<any>("loaderClass", { default: undefined });

watchImmediate(status, (to) => {
    if(to === undefined) {
        return;
    }

    loading.value = to === "pending";
});
</script>

<template>
    <div v-if="loading || status === 'pending'" :class="[loaderClasses, as === 'template' ? classes : undefined]"
        class="w-full flex-1 flex items-center h-full justify-center z-10">
        <FontAwesomeIcon :icon="faSpinnerThird" class="text-primary-500" size="2x" spin />
    </div>
    <component v-else-if="as !== 'template'" :is="as" :class="classes">
        <template v-if="!status || status === 'success'">
            <slot />
        </template>
        <template v-else-if="status === 'idle'">
            <slot name="idle" />
        </template>
        <template v-else-if="status === 'error'">
            <slot name="error" />
        </template>
    </component>
    <template v-else-if="!status || status === 'success'">
        <slot />
    </template>
    <template v-else-if="status === 'idle'">
        <slot name="idle" />
    </template>
    <template v-else-if="status === 'error'">
        <slot name="error" />
    </template>
</template>
